import React from 'react';

const FinancingCardIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
	  <g id="Group_9427" data-name="Group 9427" transform="translate(-194 -839)">
	    <g id="Ellipse_70" data-name="Ellipse 70" transform="translate(194 839)" fill="none" stroke="#e43d3c" stroke-width="2">
	      <circle cx="9" cy="9" r="9" stroke="none"/>
	      <circle cx="9" cy="9" r="8" fill="none"/>
	    </g>
	    <circle id="Ellipse_71" data-name="Ellipse 71" cx="5" cy="5" r="5" transform="translate(198 843)" fill="#e43d3c"/>
	  </g>
	</svg>
);

export default FinancingCardIcon
